<div class="w-full mx-auto p-5 max-w-4xl">
  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800">
      {{ isEditing ? 'Editar' : 'Nueva' }} URL de Relay
    </h1>
    <p class="text-gray-500 mt-1">
      {{ isEditing ? 'Modifica' : 'Configura' }} una URL para retransmitir webhooks de Wompi
    </p>
  </div>

  <!-- Formulario -->
  <form [formGroup]="relayForm" (ngSubmit)="onSubmit()" class="space-y-6">
    
    <!-- Información Básica -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-4">
      <h3 class="text-lg font-semibold text-gray-800 mb-4">Información Básica</h3>
      
      <!-- Nombre -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Nombre <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          formControlName="name"
          placeholder="Ej: Webhook a Sistema CRM"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          [ngClass]="{'border-red-500': hasError('name', 'required') || hasError('name', 'minlength')}">
        <p *ngIf="hasError('name', 'required')" class="text-red-500 text-sm mt-1">
          El nombre es obligatorio
        </p>
        <p *ngIf="hasError('name', 'minlength')" class="text-red-500 text-sm mt-1">
          El nombre debe tener al menos 3 caracteres
        </p>
      </div>

      <!-- URL Destino -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          URL de Destino <span class="text-red-500">*</span>
        </label>
        <input
          type="url"
          formControlName="targetUrl"
          placeholder="https://example.com/api/webhook"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          [ngClass]="{'border-red-500': hasError('targetUrl', 'required') || hasError('targetUrl', 'pattern')}">
        <p *ngIf="hasError('targetUrl', 'required')" class="text-red-500 text-sm mt-1">
          La URL es obligatoria
        </p>
        <p *ngIf="hasError('targetUrl', 'pattern')" class="text-red-500 text-sm mt-1">
          La URL debe comenzar con http:// o https://
        </p>
      </div>

      <!-- Descripción -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Descripción (Opcional)
        </label>
        <textarea
          formControlName="description"
          rows="3"
          placeholder="Describe el propósito de esta URL de relay..."
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          [ngClass]="{'border-red-500': hasError('description', 'maxlength')}"></textarea>
        <p *ngIf="hasError('description', 'maxlength')" class="text-red-500 text-sm mt-1">
          La descripción no puede exceder 500 caracteres
        </p>
      </div>

      <!-- Estado Activo -->
      <div class="flex items-center">
        <input
          type="checkbox"
          id="isActive"
          formControlName="isActive"
          class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
        <label for="isActive" class="ml-2 text-sm font-medium text-gray-700">
          URL Activa (los webhooks se enviarán a esta URL)
        </label>
      </div>
    </div>

    <!-- Headers Personalizados -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-4">
      <div class="flex justify-between items-center mb-4">
        <div>
          <h3 class="text-lg font-semibold text-gray-800">Headers HTTP Personalizados</h3>
          <p class="text-sm text-gray-500">Agrega headers de autenticación o personalizados</p>
        </div>
        <button
          type="button"
          (click)="addHeader()"
          class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition flex items-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Agregar Header
        </button>
      </div>

      <!-- Lista de Headers -->
      <div *ngIf="headers.length > 0" class="space-y-4">
        <div *ngFor="let header of headers.controls; let i = index" 
             [formGroup]="$any(header)"
             class="border border-gray-300 rounded-lg p-4 bg-gray-50">
          
          <div class="flex justify-between items-start mb-3">
            <h4 class="text-sm font-medium text-gray-700">Header #{{ i + 1 }}</h4>
            <button
              type="button"
              (click)="removeHeader(i)"
              class="text-red-600 hover:text-red-800 p-1 rounded-md hover:bg-red-50"
              title="Eliminar header">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Nombre del Header -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Nombre <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                formControlName="headerName"
                placeholder="Ej: Authorization, X-API-Key"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                [ngClass]="{'border-red-500': hasHeaderError(i, 'headerName', 'required')}">
              <p *ngIf="hasHeaderError(i, 'headerName', 'required')" class="text-red-500 text-sm mt-1">
                El nombre del header es obligatorio
              </p>
            </div>

            <!-- Valor del Header -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Valor <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                formControlName="headerValue"
                placeholder="Ej: Bearer token123, abc123xyz"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                [ngClass]="{'border-red-500': hasHeaderError(i, 'headerValue', 'required')}">
              <p *ngIf="hasHeaderError(i, 'headerValue', 'required')" class="text-red-500 text-sm mt-1">
                El valor del header es obligatorio
              </p>
            </div>
          </div>

          <!-- Estado del Header -->
          <div class="flex items-center mt-3">
            <input
              type="checkbox"
              [id]="'headerActive' + i"
              formControlName="isActive"
              class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
            <label [for]="'headerActive' + i" class="ml-2 text-sm font-medium text-gray-700">
              Header activo
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="headers.length === 0" class="text-center py-8 text-gray-500">
        <svg class="w-12 h-12 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
        </svg>
        <p>No hay headers configurados</p>
        <p class="text-sm">Haz clic en "Agregar Header" para añadir headers personalizados</p>
      </div>
    </div>

    <!-- Botones de Acción -->
    <div class="flex justify-end gap-3">
      <button
        type="button"
        (click)="cancel()"
        class="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition">
        Cancelar
      </button>
      <button
        type="submit"
        [disabled]="submitting"
        class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed">
        {{ submitting ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
      </button>
    </div>
  </form>
</div>

